export const terms = [
  {
    'term': 'Agency Liaison',
    'definition':
      'A representative from a city agency who collaborates with council offices to help resolve constituent cases that involve specific departmental functions.',
  },
  {
    'term': 'Aging',
    'definition':
      'The Committee on Aging has jurisdiction over issues relating to New York City’s senior residents, including the Department of the Aging, and all federal, state and municipal programs pertinent to senior citizens.',
  },
  {
    'term': 'Archive',
    'definition':
      'applies to cases that need to be removed from the system, for example duplicates, or old cases',
  },
  {
    'term': 'Assigned',
    'definition':
      'The constituent liaison at the district office working on the case.',
  },
  {
    'term': 'Borough/Block/Lot',
    'definition':
      'A combination of three numeric codes --a 1-digit borough number, a block number (up to 5 digits) and a lot number designated and modified by the department of Finance.',
  },
  {
    'term': 'Case Assignment',
    'definition':
      'The process of assigning a case to a particular staff member based on expertise, availability, or workload to ensure it is managed effectively.',
  },
  {
    'term': 'Case Management',
    'definition':
      'The process of handling individual constituent requests or issues.',
  },
  {
    'term': 'Case Priority',
    'definition':
      'The level of urgency assigned to each case is typically set as "Low," "Medium," or "High." Priority helps staff address time-sensitive cases efficiently.',
  },
  {
    'term': 'Casework',
    'definition':
      'the process of handling and addressing individual concerns, requests, or problems raised by constituents. This often involves investigating issues, coordinating with relevant agencies or departments, and advocating on behalf of constituents to resolve matters related to public services, benefits, or other government-related issues. Casework can include tasks like helping with housing issues, navigating bureaucratic processes, addressing public safety concerns, or resolving disputes with local government entities.',
  },
  {
    'term': 'City Agency',
    'definition':
      "A governmental organization or department within a city’s administrative structure that is responsible for delivering specific public services, implementing policies, and managing programs that support the city's operations.",
  },
  {
    'term': 'Civil Service and Labor',
    'definition':
      'The Committee on Civil Service and Labor has jurisdiction over New York City’s Municipal Officers and Employees, including Municipal Pension and Retirement Systems, as well as the Office of Collective Bargaining, Office of Labor Relations, and Office of Labor Services.',
  },
  {
    'term': 'Closed Case',
    'definition':
      'A case status indicating that the constituent’s issue has been resolved or addressed and no further action is required.',
  },
  {
    'term': 'Community Board',
    'definition':
      'Local groups within NYC are responsible for advising on issues in their districts. Cases may be referred to community boards for local collaboration.',
  },
  {
    'term': 'Constituent',
    'definition':
      "A resident or business within a council member's district who contacts the office with inquiries, requests, or issues.",
  },
  {
    'term': 'Constituent Profile',
    'definition':
      'A detailed record of a constituent’s contact information, interactions, case history, and preferences, allows staff to provide personalized service.',
  },
  {
    'term': 'Consumer Affairs',
    'definition':
      'The Committee on Consumer and Worker Protection has jurisdiction over New York City’s Department of Consumer Affairs and Office of Nightlife, including practices and policies relating to New Yorkers’ consumer rights.',
  },
  {
    'term': 'Council District',
    'definition':
      'A specific geographic area is represented by a city council member, which determines the constituents served by the office.',
  },
  {
    'term': 'Cultural Affairs',
    'definition':
      'The Committee on Cultural Affairs, Libraries, and International Intergroup Relations has jurisdiction over the Department of Cultural Affairs, libraries, museums, Art Commission, New York City Commission for the United Nations, Consular Corps and Protocol, Mayor’s Office of Special Projects and Community Events, and to encourage harmony among the citizens of New York City, to promote the image of New York City and enhance the relationship of its citizens with the international community.',
  },
  {
    'term': 'Economy/Jobs',
    'definition':
      'The Committee on Economic Development has jurisdiction over New York City’s Economic Development Corporation',
  },
  {
    'term': 'Education',
    'definition':
      'The Committee on Education has jurisdiction over New York City’s Department of Education, School Construction Authority, and the City’s charter school networks.',
  },
  {
    'term': 'Environment',
    'definition':
      'The Committee on Environmental Protection, Resiliency and Waterfronts has jurisdiction over New York City’s Department of Environmental Protection, the Office of Recovery and Resiliency, and the Office of Long Term Planning and Sustainability as it relates to efforts to make New York City more resilient in the face of climate change, and preparing for, responding to, and recovering from emergencies, and matters relating to the waterfront.',
  },
  {
    'term': 'Escalation',
    'definition':
      'The process of forwarding a case to a higher authority or another department when additional expertise or approval is required to resolve it.',
  },
  {
    'term': 'Finance',
    'definition':
      "The Committee on Finance has jurisdiction over New York City’s Banking Commission, Executive Budget review and Budget modification, Comptroller's Office, Department of Finance, Independent Budget Office and fiscal policy and revenue from any source.",
  },
  {
    'term': 'Fire and Emergency Management',
    'definition':
      'The Committee on Fire and Emergency Management has jurisdiction over New York City’s Department of Emergency Medical Services (for non-health related issues), Emergency Management Department (OEM), and Fire Department.',
  },
  {
    'term': 'FOIL',
    'definition':
      'A Freedom of Information Law (FOIL) provides rights of access to records reflective of governmental decisions and policies that affect the lives of every New Yorker. The public has the right to access records maintained by government agencies with certain exceptions.',
  },
  {
    'term': 'Follow-Up',
    'definition':
      'An action reminding staff to reach out to constituents or other departments involved in resolving a case. Follow-ups are crucial for maintaining communication and completing cases.',
  },
  {
    'term': 'General Topic',
    'definition':
      'A general category used by The Council to classify constituents\' cases based on their nature, such as "Housing," "Public Safety," "Transportation," "Education," or "Sanitation." This helps to organize cases and determine resource allocation. The classification system takes from some of The Council\'s Committees.',
  },
  {
    'term': 'General Welfare',
    'definition':
      'The Committee on General Welfare has jurisdiction over New York City’s Human Resources Administration/Department of Social Services, Department of Homeless Services, and charitable institutions.',
  },
  {
    'term': 'Governmental Operations',
    'definition':
      'The Committee on Governmental Operations, State & Federal Legislation has jurisdiction over Federal and State legislation (including Home Rule requests), municipal governmental structure and organization, including New York City’s Department of Citywide Administrative Services, Office of Administrative Trials and Hearings, Board of Elections, Board of Standards and Appeals, Campaign Finance Board, Commission on Public Information and Communication, Community Boards, Department of Records and Information Services, Financial Services Agency, and the Law Department.',
  },
  {
    'term': 'Greenbook',
    'definition':
      'is the official directory of the City of New York. It is an indispensable reference guide for anyone living or working in New York City. The Green Book includes detailed listings of contacts within each agency.',
  },
  {
    'term': 'Groups',
    'definition':
      'A category for grouping constituents based on demographic or interest (e.g., senior citizens, small business owners, youth) to enable targeted outreach or track Citizen Opinion',
  },
  {
    'term': 'Groups',
    'definition':
      'A category for grouping constituents based on demographic or interest (e.g., senior citizens, small business owners, youth) to enable targeted outreach or track Citizen Opinions.',
  },
  {
    'term': 'Health',
    'definition':
      'The Committee on Health has jurisdiction over New York City’s Department of Health and Mental Hygiene, Emergency Medical Services (for health-related issues), and the Office of the Chief Medical Examiner.',
  },
  {
    'term': 'Housing and Buildings',
    'definition':
      'The Committee on Housing and Buildings has jurisdiction over New York City’s rent regulation policies and practices, as well as the Department of Buildings and Department of Housing Preservation and Development.',
  },
  {
    'term': 'Human and Civil Rights',
    'definition':
      'The Committee on Civil Rights has jurisdiction over New York City’s Equal Employment Practices Commission and Human Rights Commission, as well as citywide Equal Employment Opportunity practices and policies.',
  },
  {
    'term': 'Immigration',
    'definition':
      'The Committee on Immigration has jurisdiction over New York City matters affecting immigration, including the Mayor’s Office of Immigrant Affairs.',
  },
  {
    'term': 'In-Progress',
    'definition': 'a case that is active and is assigned to a staff',
  },
  {
    'term': 'Intake',
    'definition':
      'The initial medium through which the constituent contacted the council district office. This can be done via phone, email, social media, walk-in, letters, text messages, or online.',
  },
  {
    'term': 'Land Use and Zoning',
    'definition':
      'The Committee on Land Use has jurisdiction over New York City’s land use and landmarks review process, as well as the City Planning Commission, Department of City Planning, Department of Information Technology and Telecommunications, and Landmarks Preservation Commission.',
  },
  {
    'term': 'Notes',
    'definition':
      'Free-text fields where staff can document details about each case, constituent preferences, and any steps taken or advice given.',
  },
  {
    'term': 'On Hold - Agency',
    'definition': 'case was processed and now waits for Agency response',
  },
  {
    'term': 'On Hold-Constituent',
    'definition':
      'case waits for additional information or documentation from Constituent to continue the process',
  },
  {
    'term': 'Parks',
    'definition':
      'The Committee on Parks and Recreation has jurisdiction over New York City’s Department of Parks and Recreation.',
  },
  {
    'term': 'Pending',
    'definition': 'a case waiting to be initiated by a staff',
  },
  {
    'term': 'Personal Information',
    'definition':
      'Any data that could be used to identify specific individuals. A full name, home address, phone number, ID number, email address, and biometric records are all examples of personal information.',
  },
  {
    'term': 'Privacy',
    'definition': 'Appropriate use of any collected, stored, and shared data.',
  },
  {
    'term': 'Public Safety',
    'definition':
      'The Committee on Public Safety has jurisdiction over New York City’s Police Department, Civilian Complaint Review Board, Mayor’s Office of Criminal Justice, courts, legal services, District Attorneys, and the Office of the Special Narcotics Prosecutor.',
  },
  {
    'term': 'Quality of Life',
    'definition':
      'Related to General Welfare, New York City’s Police Department, Civilian Complaint Review Board, courts.',
  },
  {
    'term': 'Record',
    'definition':
      'Any information kept, held, filed, produced, or reproduced by, with, or for this district office, in any physical form whatsoever including, but not limited to, reports, statements, examinations, memoranda, opinions, folders, files, books, manuals, pamphlets, forms, papers, designs, drawings, maps, photos, letters, microfilms, computer tapes or disks, rules, regulations or codes.',
  },
  {
    'term': 'Referral',
    'definition':
      'When a case is redirected to another agency, organization, or office for further action if it falls outside the city council’s jurisdiction.',
  },
  {
    'term': 'Resolution',
    'definition':
      "The outcome or solution provided to address a constituent's case.",
  },
  {
    'term': 'Sanitation',
    'definition':
      'The Committee on Sanitation and Solid Waste Management has jurisdiction over New York City’s Business Integrity Commission and the Department of Sanitation.',
  },
  {
    'term': 'Service Request',
    'definition':
      'A request for a specific service or information, such as a request for garbage removal, pothole repair, or housing assistance, is initiated by the constituent',
  },
  {
    'term': 'SLA (Service Level Agreement)',
    'definition':
      'A predefined timeline within which a case should be addressed or resolved, based on urgency and type. SLAs help ensure timely response to constituents.',
  },
  {
    'term': 'Small Business',
    'definition':
      'The Committee on Small Business has jurisdiction over New York City matters relating to retail business and emerging commercial industries.',
  },
  {
    'term': 'Status',
    'definition':
      'The current state of a case. It helps prioritize follow-ups and determine the overall workload.',
  },
  {
    'term': 'Tags',
    'definition':
      "Provide an easy way to categorize, flag, and locate records. You can use tags on the constituent or casework section. Keywords or labels added to cases or constituent's profiles to help categorize or identify trends (e.g., budget-related, community event, Bill 100-Oposse).",
  },
  {
    'term': 'Topic',
    'definition':
      'A descriptive subcategory of General Topics used on caseworks.',
  },
  {
    'term': 'Transfer',
    'definition':
      'case has been transferred from or to another district office.',
  },
  {
    'term': 'Transportation',
    'definition':
      'The Committee on Transportation and Infrastructure has jurisdiction over New York City’s mass transportation agencies and facilities, including the Department of Transportation, New York City Transit Authority, and Taxi and Limousine Commission.',
  },
  {
    'term': 'Utilities',
    'definition':
      'Utilities refer to services provided by public or private organizations that are essential for daily living and business operations. These services typically include electricity, water, gas, and telecommunications.',
  },
  {
    'term': 'Veterans Affairs',
    'definition':
      'The Committee on Veterans has jurisdiction over matters relating to New York City’s Department of Veterans’ Services and other veteran related issues.',
  },
  {
    'term': 'Youth Services',
    'definition':
      'The Committee on Children and Youth has jurisdiction over New York City’s youth-related programs, including the Administration for Children’s Services, Department of Youth and Community Development, Inter-agency Coordinating Council on Youth, and Youth Board.',
  },
]
